// import { useState } from "react";
// import toast from "react-hot-toast";
// import { useAuthStore } from "../../context/useAuthStore";
// import { AuthButton } from "../common/AuthButton";
// import PhoneNumberInput from "./PhoneNumberInput";
// import PasswordInput from "./PasswordInput";
// import { LuUser } from "react-icons/lu";
// import { FiMail } from "react-icons/fi";
// import { validateEmail } from "../../utils/validation";
// import TextInput from "./TextInput";
// import SelectInput from "./SelectInput";

// const Admin = import.meta.env.VITE_ADMIN_ID;
// const ProductTeam = import.meta.env.VITE_PRODUCT_TEAM_ID;

// type AddNewAdminProps = {
//   onEnrollSuccess?: () => void;
// };

// const roleOptions = [
//   { label: "Admin", value: Admin },
//   { label: "Product Team", value: ProductTeam },
// ];

// export const AddNewAdmin: React.FC<AddNewAdminProps> = ({
//   onEnrollSuccess,
// }) => {
//   const { registerAdmin } = useAuthStore();
//   const [loading, setLoading] = useState(false);
//   const [errors, setErrors] = useState<Record<string, string>>({});

//   const initialForm = {
//     fullName: "",
//     emailId: "",
//     phoneNumber: "",
//     address: "28 Doyens Township Seri lingampally ",
//     yearOfStudy: "0",
//     college: "Saadruso Internet Media Pvt Ltd",
//     rollNumber: "007",
//     password: "",
//     roleId: Admin,
//     userId: "",
//   };

//   const [form, setForm] = useState(initialForm);

//   const validateField = (name: string, value: string) => {
//     if (!value.trim()) return "This field is required";
//     if (name === "emailId" && !validateEmail(value))
//       return "Please enter a valid email address";
//     if (name === "phoneNumber" && value.replace(/\D/g, "").length < 10)
//       return "Please enter a valid phone number";
//     if (name === "password" && value.length < 8)
//       return "Password must be at least 8 characters";
//     return "";
//   };

//   const validateForm = () => {
//     const newErrors: Record<string, string> = {};
//     let isValid = true;

//     Object.entries(form).forEach(([name, value]) => {
//       if (name === "roleId" || name === "userId") return;
//       const error = validateField(name, value);
//       if (error) isValid = false;
//       newErrors[name] = error;
//     });

//     setErrors(newErrors);
//     return isValid;
//   };

//   const handleChange = (name: string, value: string) => {
//     setForm((prev) => ({ ...prev, [name]: value }));
//     if (errors[name]) {
//       setErrors((prev) => ({ ...prev, [name]: "" }));
//     }
//   };

//   const handleSubmit = async (e: React.FormEvent) => {
//     e.preventDefault();

//     if (!validateForm()) {
//       toast.error("Please fix the errors in the form");
//       return;
//     }

//     setLoading(true);
//     try {
//       const userData = {
//         ...form,
//         fullName: form.fullName.trim(),
//         emailId: form.emailId.trim().toLowerCase(),
//         phoneNumber: form.phoneNumber.trim(),
//       };
//       await registerAdmin(userData);
//       setForm(initialForm);
//       onEnrollSuccess?.();
//     } catch (error: any) {
//       let message = "Registration failed. Please try again.";
//       if (error?.response?.status === 409) {
//         message = "Email or phone number already registered";
//         setErrors((prev) => ({ ...prev, emailId: message }));
//       } else if (error?.message) {
//         message = error.message;
//       }
//       toast.error(message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const isFormValid =
//     Object.entries(form)
//       .filter(([key]) => key !== "roleId" && key !== "userId")
//       .every(([, value]) => value.trim()) &&
//     Object.values(errors).every((e) => !e);

//   const fields = [
//     { id: "fullName", label: "Full Name", icon: LuUser },
//     { id: "emailId", label: "Email Address", icon: FiMail, type: "email" },
//     { id: "phoneNumber", label: "Mobile Number", phone: true },
//     { id: "password", label: "Password", password: true },
//   ];

//   return (
//     <section className="subjectSection">
//       <h2 className="subjectTitle">Create new admin</h2>
//       <div className="borderLine"></div>
//       <form onSubmit={handleSubmit} className="space-y-4">
//         <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
//           {fields.map(({ id, label, icon, type, phone, password }) =>
//             phone ? (
//               <PhoneNumberInput
//                 key={id}
//                 value={form.phoneNumber}
//                 onChange={(val) => handleChange("phoneNumber", val)}
//                 label={label}
//                 required
//                 errorMessage={errors.phoneNumber}
//                 disabled={loading}
//               />
//             ) : password ? (
//               <PasswordInput
//                 key={id}
//                 id={id}
//                 name={id}
//                 label={label}
//                 value={form.password}
//                 onChange={(e) => handleChange(id, e.target.value)}
//                 placeholder={`Enter your ${label.toLowerCase()}`}
//                 required
//                 errorMessage={errors.password}
//                 disabled={loading}
//               />
//             ) : (
//               <TextInput
//                 key={id}
//                 id={id}
//                 name={id}
//                 label={label}
//                 type={type || "text"}
//                 value={form[id as keyof typeof form]}
//                 onChange={(e) => handleChange(id, e.target.value)}
//                 placeholder={`Enter your ${label.toLowerCase()}`}
//                 required
//                 errorMessage={errors[id]}
//                 icon={icon}
//                 disabled={loading}
//               />
//             )
//           )}
//         </div>
//         <AuthButton
//           title="Create Admin"
//           loadingTitle="Creating new admin..."
//           loading={loading}
//           disabled={!isFormValid || loading}
//         />
//       </form>
//     </section>
//   );
// };

import { useState } from "react";
import toast from "react-hot-toast";
import { useAuthStore } from "../../context/useAuthStore";
import { AuthButton } from "../common/AuthButton";
import PhoneNumberInput from "./PhoneNumberInput";
import PasswordInput from "./PasswordInput";
import { LuUser } from "react-icons/lu";
import { FiMail } from "react-icons/fi";
import { validateEmail } from "../../utils/validation";
import TextInput from "./TextInput";
import SelectInput from "./SelectInput";

const Admin = import.meta.env.VITE_ADMIN_ID;
const ProductTeam = import.meta.env.VITE_PRODUCT_TEAM_ID;

type AddNewAdminProps = {
  onEnrollSuccess?: () => void;
};

const roleOptions = [
  { label: "Admin", value: Admin },
  { label: "Product Team", value: ProductTeam },
];

export const AddNewAdmin: React.FC<AddNewAdminProps> = ({
  onEnrollSuccess,
}) => {
  const { registerAdmin } = useAuthStore();
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState<Record<string, string>>({});

  const initialForm = {
    fullName: "",
    emailId: "",
    phoneNumber: "",
    address: "28 Doyens Township Seri lingampally",
    yearOfStudy: "0",
    college: "Saadruso Internet Media Pvt Ltd",
    rollNumber: "007",
    password: "",
    roleId: "",
    userId: "",
    tcStatus: "true",
  };

  const [form, setForm] = useState(initialForm);

  /* -------------------------------------------------------------------------- */
  /*                               VALIDATION LOGIC                             */
  /* -------------------------------------------------------------------------- */

  const validateField = (name: string, value: string) => {
    if (!value.trim()) return "This field is required";

    if (name === "emailId" && !validateEmail(value)) {
      return "Please enter a valid email address";
    }

    if (name === "phoneNumber" && value.replace(/\D/g, "").length < 10) {
      return "Please enter a valid phone number";
    }

    if (name === "password" && value.length < 8) {
      return "Password must be at least 8 characters";
    }

    if (name === "roleId" && !value) {
      return "Please select a role";
    }

    return "";
  };

  const validateForm = () => {
    const newErrors: Record<string, string> = {};
    let isValid = true;

    Object.entries(form).forEach(([name, value]) => {
      if (name === "userId") return; // skip

      const error = validateField(name, value);
      if (error) isValid = false;
      newErrors[name] = error;
    });

    setErrors(newErrors);
    return isValid;
  };

  /* -------------------------------------------------------------------------- */
  /*                             FORM CHANGE HANDLER                            */
  /* -------------------------------------------------------------------------- */

  const handleChange = (name: string, value: string) => {
    setForm((prev) => ({ ...prev, [name]: value }));

    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                                SUBMIT FORM                                 */
  /* -------------------------------------------------------------------------- */
  const getRoleName = (roleId: string) => {
    if (roleId === Admin) return "Admin";
    if (roleId === ProductTeam) return "Product Team";
    return "Unknown Role";
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!validateForm()) {
      toast.error("Please fix the errors in the form");
      return;
    }

    setLoading(true);

    try {
      const userData = {
        ...form,
        fullName: form.fullName.trim(),
        emailId: form.emailId.trim().toLowerCase(),
        phoneNumber: form.phoneNumber.trim(),
      };

      await registerAdmin(userData);
      setForm(initialForm);
      toast.success(`New ${getRoleName(form.roleId)} created successfully!`);

      onEnrollSuccess?.();
    } catch (error: any) {
      let message = "Registration failed. Please try again.";

      if (error?.response?.status === 409) {
        message = "Email or phone number already registered";
        setErrors((prev) => ({ ...prev, emailId: message }));
      } else if (error?.message) {
        message = error.message;
      }

      toast.error(message);
    } finally {
      setLoading(false);
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                             FORM FIELDS CONFIG                             */
  /* -------------------------------------------------------------------------- */

  const fields = [
    { id: "fullName", label: "Full Name", icon: LuUser },
    { id: "emailId", label: "Email Address", icon: FiMail, type: "email" },
    { id: "phoneNumber", label: "Mobile Number", phone: true },
    { id: "password", label: "Password", password: true },
  ];

  const isFormValid =
    Object.entries(form)
      .filter(([key]) => key !== "userId")
      .every(([, value]) => value.trim()) &&
    Object.values(errors).every((e) => !e);

  /* -------------------------------------------------------------------------- */
  /*                                  UI RENDER                                 */
  /* -------------------------------------------------------------------------- */

  return (
    <section className="subjectSection">
      <h2 className="subjectTitle">Create new admin</h2>
      <div className="borderLine"></div>

      <form onSubmit={handleSubmit} className="space-y-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {/* ---------------------------- ROLE SELECT ---------------------------- */}
          <SelectInput
            name="roleId"
            label="Select Role"
            value={form.roleId}
            onChange={(val) => handleChange("roleId", val)}
            options={roleOptions}
            placeholder="Select a role"
            required
            error={!!errors.roleId}
            errorMessage={errors.roleId}
          />

          {/* --------------------------- OTHER FIELDS --------------------------- */}
          {fields.map(({ id, label, icon, type, phone, password }) =>
            phone ? (
              <PhoneNumberInput
                key={id}
                value={form.phoneNumber}
                onChange={(val) => handleChange("phoneNumber", val)}
                label={label}
                required
                errorMessage={errors.phoneNumber}
                disabled={loading}
              />
            ) : password ? (
              <PasswordInput
                key={id}
                id={id}
                name={id}
                label={label}
                value={form.password}
                onChange={(e) => handleChange(id, e.target.value)}
                placeholder={`Enter your ${label.toLowerCase()}`}
                required
                errorMessage={errors.password}
                disabled={loading}
              />
            ) : (
              <TextInput
                key={id}
                id={id}
                name={id}
                label={label}
                type={type || "text"}
                value={form[id as keyof typeof form]}
                onChange={(e) => handleChange(id, e.target.value)}
                placeholder={`Enter your ${label.toLowerCase()}`}
                required
                errorMessage={errors[id]}
                icon={icon}
                disabled={loading}
              />
            )
          )}
        </div>

        <AuthButton
          title="Create Admin"
          loadingTitle="Creating new admin..."
          loading={loading}
          disabled={!isFormValid || loading}
        />
      </form>
    </section>
  );
};
